export default __webpack_public_path__ + "static/media/Satyajit Parthasarthi Nsyak - Vice President, NIBA Alumni Association.c70f5168.jpg";